// src/index.tsx
import * as React9 from "react";
import { useMemo as useMemo2 } from "react";
import { getCompatContextProvider } from "react-querybuilder";

// src/MaterialActionElement.tsx
import * as React from "react";
import { useContext } from "react";
import { ActionElement } from "react-querybuilder";

// src/RQBMaterialContext.ts
import { createContext } from "react";
var RQBMaterialContext = createContext(null);
RQBMaterialContext.displayName = "RQBMaterialContext";

// src/MaterialActionElement.tsx
var MaterialActionElement = ({
  className,
  handleOnClick,
  label,
  title,
  disabled,
  disabledTranslation,
  testID,
  path,
  level,
  rules,
  context,
  validation,
  ruleOrGroup,
  schema,
  muiComponents: muiComponentsProp,
  ...otherProps
}) => {
  const muiComponents = useContext(RQBMaterialContext) ?? muiComponentsProp;
  const key = muiComponents ? "mui" : "no-mui";
  if (!muiComponents) {
    const AE = ActionElement;
    return /* @__PURE__ */ React.createElement(
      AE,
      {
        key,
        className,
        handleOnClick,
        label,
        title,
        disabled,
        disabledTranslation,
        testID,
        path,
        level,
        rules,
        context,
        validation,
        ruleOrGroup,
        schema
      }
    );
  }
  const { Button: Button2 } = muiComponents;
  return /* @__PURE__ */ React.createElement(
    Button2,
    {
      key,
      variant: "contained",
      color: "secondary",
      className,
      title: disabledTranslation && disabled ? disabledTranslation.title : title,
      size: "small",
      disabled: disabled && !disabledTranslation,
      onClick: (e) => handleOnClick(e),
      ...otherProps
    },
    disabledTranslation && disabled ? disabledTranslation.label : label
  );
};
MaterialActionElement.displayName = "MaterialActionElement";

// src/MaterialDragHandle.tsx
import * as React2 from "react";
import { forwardRef, useContext as useContext2 } from "react";
import { DragHandle } from "react-querybuilder";
var MaterialDragHandle = forwardRef(
  ({
    className,
    title,
    path,
    level,
    testID,
    label,
    disabled,
    context,
    validation,
    schema,
    ruleOrGroup,
    muiComponents: muiComponentsProp,
    ...otherProps
  }, dragRef) => {
    const muiComponents = useContext2(RQBMaterialContext) ?? muiComponentsProp;
    const key = muiComponents ? "mui" : "no-mui";
    if (!muiComponents) {
      return /* @__PURE__ */ React2.createElement(
        DragHandle,
        {
          key,
          path,
          level,
          className,
          title,
          testID,
          label,
          disabled,
          context,
          validation,
          schema,
          ruleOrGroup
        }
      );
    }
    const { DragIndicator: DragIndicator2 } = muiComponents;
    return /* @__PURE__ */ React2.createElement("span", { key, ref: dragRef, className, title }, /* @__PURE__ */ React2.createElement(DragIndicator2, { ...otherProps }));
  }
);
MaterialDragHandle.displayName = "MaterialDragHandle";

// src/MaterialNotToggle.tsx
import * as React3 from "react";
import { useContext as useContext3 } from "react";
import { NotToggle } from "react-querybuilder";
var MaterialNotToggle = ({
  className,
  handleOnChange,
  label,
  checked,
  title,
  disabled,
  level,
  path,
  context,
  validation,
  testID,
  schema,
  ruleGroup,
  muiComponents: muiComponentsProp,
  ...otherProps
}) => {
  const muiComponents = useContext3(RQBMaterialContext) ?? muiComponentsProp;
  const key = muiComponents ? "mui" : "no-mui";
  if (!muiComponents) {
    return /* @__PURE__ */ React3.createElement(
      NotToggle,
      {
        key,
        className,
        handleOnChange,
        label,
        checked,
        title,
        disabled,
        path,
        level,
        context,
        validation,
        testID,
        schema,
        ruleGroup
      }
    );
  }
  const { FormControlLabel: FormControlLabel2, Switch: Switch2 } = muiComponents;
  return /* @__PURE__ */ React3.createElement(
    FormControlLabel2,
    {
      key,
      className,
      title,
      disabled,
      control: /* @__PURE__ */ React3.createElement(
        Switch2,
        {
          checked: !!checked,
          onChange: (e) => handleOnChange(e.target.checked),
          ...otherProps
        }
      ),
      label: label ?? /* istanbul ignore next */
      ""
    }
  );
};
MaterialNotToggle.displayName = "MaterialNotToggle";

// src/MaterialShiftActions.tsx
import * as React4 from "react";
import { ShiftActions } from "react-querybuilder";
var MaterialShiftActions = ({
  path,
  shiftUp,
  shiftDown,
  shiftUpDisabled,
  shiftDownDisabled,
  disabled,
  className,
  labels,
  titles,
  testID,
  muiComponents: muiComponentsProp,
  ...otherProps
}) => {
  const muiComponents = React4.useContext(RQBMaterialContext) ?? muiComponentsProp;
  const key = muiComponents ? "mui" : "no-mui";
  if (!muiComponents) {
    return /* @__PURE__ */ React4.createElement(
      ShiftActions,
      {
        key,
        path,
        disabled,
        className,
        labels,
        titles,
        testID,
        shiftUp,
        shiftDown,
        shiftUpDisabled,
        shiftDownDisabled,
        ...otherProps
      }
    );
  }
  const { Button: Button2 } = muiComponents;
  return /* @__PURE__ */ React4.createElement("div", { key, "data-testid": testID, className }, /* @__PURE__ */ React4.createElement(
    Button2,
    {
      sx: { boxShadow: "none" },
      variant: "contained",
      color: "secondary",
      className,
      title: titles?.shiftUp,
      size: "small",
      disabled: disabled || shiftUpDisabled,
      onClick: shiftUp
    },
    labels?.shiftUp
  ), /* @__PURE__ */ React4.createElement(
    Button2,
    {
      sx: { boxShadow: "none" },
      variant: "contained",
      color: "secondary",
      className,
      title: titles?.shiftDown,
      size: "small",
      disabled: disabled || shiftDownDisabled,
      onClick: shiftDown
    },
    labels?.shiftDown
  ));
};
MaterialShiftActions.displayName = "MaterialShiftActions";

// src/MaterialValueEditor.tsx
import * as React5 from "react";
import { useContext as useContext5 } from "react";
import {
  getFirstOption,
  standardClassnames,
  useValueEditor,
  ValueEditor
} from "react-querybuilder";
var MaterialValueEditor = (props) => {
  const { muiComponents: muiComponentsProp, ...propsForValueEditor } = props;
  const {
    field: _f,
    fieldData,
    operator,
    value,
    handleOnChange,
    title,
    className,
    type,
    path,
    level,
    inputType,
    values = [],
    listsAsArrays,
    parseNumbers,
    separator,
    valueSource: _vs,
    disabled,
    testID,
    selectorComponent: SelectorComponent = props.schema.controls.valueSelector,
    extraProps,
    ...propsForValueSelector
  } = propsForValueEditor;
  const muiComponents = useContext5(RQBMaterialContext) ?? muiComponentsProp;
  const { valueAsArray, multiValueHandler } = useValueEditor({
    handleOnChange,
    inputType,
    operator,
    value,
    type,
    listsAsArrays,
    parseNumbers,
    values
  });
  const masterKey = muiComponents ? "mui" : "no-mui";
  if (!muiComponents) {
    return /* @__PURE__ */ React5.createElement(ValueEditor, { skipHook: true, key: masterKey, ...propsForValueEditor });
  }
  const {
    Checkbox: Checkbox2,
    FormControl: FormControl2,
    FormControlLabel: FormControlLabel2,
    Input: Input2,
    Radio: Radio2,
    RadioGroup: RadioGroup2,
    Switch: Switch2,
    TextareaAutosize: TextareaAutosize2
  } = muiComponents;
  if (operator === "null" || operator === "notNull") {
    return null;
  }
  const placeHolderText = fieldData?.placeholder ?? "";
  const inputTypeCoerced = ["in", "notIn"].includes(operator) ? "text" : inputType || "text";
  if ((operator === "between" || operator === "notBetween") && (type === "select" || type === "text")) {
    const editors = ["from", "to"].map((key, i) => {
      if (type === "text") {
        return /* @__PURE__ */ React5.createElement(
          Input2,
          {
            key,
            type: inputTypeCoerced,
            className: standardClassnames.valueListItem,
            value: valueAsArray[i] ?? "",
            disabled,
            placeholder: placeHolderText,
            onChange: (e) => multiValueHandler(e.target.value, i),
            ...extraProps
          }
        );
      }
      return /* @__PURE__ */ React5.createElement(
        SelectorComponent,
        {
          ...propsForValueSelector,
          key,
          path,
          level,
          className: standardClassnames.valueListItem,
          handleOnChange: (v) => multiValueHandler(v, i),
          muiComponents,
          disabled,
          value: valueAsArray[i] ?? getFirstOption(values),
          options: values,
          listsAsArrays
        }
      );
    });
    return /* @__PURE__ */ React5.createElement("span", { key: masterKey, "data-testid": testID, className, title }, editors[0], separator, editors[1]);
  }
  switch (type) {
    case "select":
    case "multiselect":
      return /* @__PURE__ */ React5.createElement(
        SelectorComponent,
        {
          ...propsForValueSelector,
          muiComponents,
          key: masterKey,
          path,
          level,
          className,
          handleOnChange,
          options: values,
          value,
          disabled,
          title,
          multiple: type === "multiselect",
          listsAsArrays
        }
      );
    case "textarea":
      return /* @__PURE__ */ React5.createElement(
        TextareaAutosize2,
        {
          key: masterKey,
          value,
          title,
          disabled,
          className,
          placeholder: placeHolderText,
          onChange: (e) => handleOnChange(e.target.value),
          ...extraProps
        }
      );
    case "switch":
      return /* @__PURE__ */ React5.createElement(
        Switch2,
        {
          key: masterKey,
          checked: !!value,
          title,
          disabled,
          className,
          onChange: (e) => handleOnChange(e.target.checked),
          ...extraProps
        }
      );
    case "checkbox":
      return /* @__PURE__ */ React5.createElement(
        Checkbox2,
        {
          key: masterKey,
          className,
          title,
          onChange: (e) => handleOnChange(e.target.checked),
          checked: !!value,
          disabled,
          ...extraProps
        }
      );
    case "radio":
      return /* @__PURE__ */ React5.createElement(
        FormControl2,
        {
          key: masterKey,
          className,
          title,
          component: "fieldset",
          disabled,
          ...extraProps
        },
        /* @__PURE__ */ React5.createElement(RadioGroup2, { value, onChange: (e) => handleOnChange(e.target.value) }, values.map((v) => /* @__PURE__ */ React5.createElement(
          FormControlLabel2,
          {
            disabled,
            key: v.name,
            value: v.name,
            control: /* @__PURE__ */ React5.createElement(Radio2, null),
            label: v.label
          }
        )))
      );
  }
  return /* @__PURE__ */ React5.createElement(
    Input2,
    {
      key: masterKey,
      type: inputTypeCoerced,
      value,
      title,
      disabled,
      className,
      placeholder: placeHolderText,
      onChange: (e) => handleOnChange(e.target.value),
      ...extraProps
    }
  );
};
MaterialValueEditor.displayName = "MaterialValueEditor";

// src/MaterialValueSelector.tsx
import * as React7 from "react";
import { useContext as useContext6 } from "react";
import { ValueSelector, useValueSelector } from "react-querybuilder";

// src/utils.tsx
import * as React6 from "react";
import { isOptionGroupArray } from "react-querybuilder";
var toOptions = (arr, { ListSubheader: ListSubheader2, MenuItem: MenuItem2 }) => {
  if (isOptionGroupArray(arr)) {
    const optArray = [];
    for (const og of arr) {
      optArray.push(
        /* @__PURE__ */ React6.createElement(ListSubheader2, { key: og.label }, og.label),
        ...og.options.map((opt) => /* @__PURE__ */ React6.createElement(MenuItem2, { key: opt.name, value: opt.name }, opt.label))
      );
    }
    return optArray;
  }
  if (Array.isArray(arr)) {
    return arr.map((opt) => /* @__PURE__ */ React6.createElement(MenuItem2, { key: opt.name, value: opt.name }, opt.label));
  }
  return null;
};

// src/MaterialValueSelector.tsx
var MaterialValueSelector = ({
  className,
  handleOnChange,
  options,
  value,
  disabled,
  title,
  multiple,
  listsAsArrays,
  testID,
  rule,
  rules,
  level,
  path,
  context,
  validation,
  operator,
  field,
  fieldData,
  schema,
  muiComponents: muiComponentsProp,
  defaultValue: _defaultValue,
  ...otherProps
}) => {
  const muiComponents = useContext6(RQBMaterialContext) ?? muiComponentsProp;
  const { onChange, val } = useValueSelector({ handleOnChange, listsAsArrays, multiple, value });
  const muiSelectChangeHandler = ({ target: { value: value2 } }) => onChange(value2);
  const key = muiComponents ? "mui" : "no-mui";
  if (!muiComponents) {
    const VS = ValueSelector;
    return /* @__PURE__ */ React7.createElement(
      VS,
      {
        key,
        className,
        handleOnChange,
        options,
        value,
        disabled,
        title,
        multiple,
        listsAsArrays,
        testID,
        rule,
        rules,
        level,
        path,
        context,
        validation,
        operator,
        field,
        fieldData,
        schema
      }
    );
  }
  const { FormControl: FormControl2, Select: Select2, ListSubheader: ListSubheader2, MenuItem: MenuItem2 } = muiComponents;
  return /* @__PURE__ */ React7.createElement(
    FormControl2,
    {
      key,
      variant: "standard",
      className,
      title,
      disabled
    },
    /* @__PURE__ */ React7.createElement(Select2, { value: val, onChange: muiSelectChangeHandler, multiple, ...otherProps }, toOptions(options ?? /* istanbul ignore next */
    [], {
      ListSubheader: ListSubheader2,
      MenuItem: MenuItem2
    }))
  );
};
MaterialValueSelector.displayName = "MaterialValueSelector";

// src/translations.tsx
import * as React8 from "react";
import { defaultTranslations } from "react-querybuilder";
var CloseIconWrapper = () => {
  const muiComponents = React8.useContext(RQBMaterialContext);
  if (!muiComponents) {
    return defaultTranslations.removeRule.label;
  }
  const { CloseIcon: CloseIcon2 } = muiComponents;
  return /* @__PURE__ */ React8.createElement(CloseIcon2, null);
};
var ContentCopyIconWrapper = () => {
  const muiComponents = React8.useContext(RQBMaterialContext);
  if (!muiComponents) {
    return defaultTranslations.cloneRule.label;
  }
  const { ContentCopyIcon: ContentCopyIcon2 } = muiComponents;
  return /* @__PURE__ */ React8.createElement(ContentCopyIcon2, null);
};
var LockIconWrapper = () => {
  const muiComponents = React8.useContext(RQBMaterialContext);
  if (!muiComponents) {
    return defaultTranslations.lockRuleDisabled.label;
  }
  const { LockIcon: LockIcon2 } = muiComponents;
  return /* @__PURE__ */ React8.createElement(LockIcon2, null);
};
var LockOpenIconWrapper = () => {
  const muiComponents = React8.useContext(RQBMaterialContext);
  if (!muiComponents) {
    return defaultTranslations.lockRule.label;
  }
  const { LockOpenIcon: LockOpenIcon2 } = muiComponents;
  return /* @__PURE__ */ React8.createElement(LockOpenIcon2, null);
};
var ShiftDownIconWrapper = () => {
  const muiComponents = React8.useContext(RQBMaterialContext);
  if (!muiComponents) {
    return defaultTranslations.shiftActionDown.label;
  }
  const { KeyboardArrowDownIcon: KeyboardArrowDownIcon2 } = muiComponents;
  return /* @__PURE__ */ React8.createElement(KeyboardArrowDownIcon2, null);
};
var ShiftUpIconWrapper = () => {
  const muiComponents = React8.useContext(RQBMaterialContext);
  if (!muiComponents) {
    return defaultTranslations.shiftActionUp.label;
  }
  const { KeyboardArrowUpIcon: KeyboardArrowUpIcon2 } = muiComponents;
  return /* @__PURE__ */ React8.createElement(KeyboardArrowUpIcon2, null);
};
var materialTranslations = {
  removeGroup: { label: /* @__PURE__ */ React8.createElement(CloseIconWrapper, null) },
  removeRule: { label: /* @__PURE__ */ React8.createElement(CloseIconWrapper, null) },
  cloneRule: { label: /* @__PURE__ */ React8.createElement(ContentCopyIconWrapper, null) },
  cloneRuleGroup: { label: /* @__PURE__ */ React8.createElement(ContentCopyIconWrapper, null) },
  lockGroup: { label: /* @__PURE__ */ React8.createElement(LockOpenIconWrapper, null) },
  lockRule: { label: /* @__PURE__ */ React8.createElement(LockOpenIconWrapper, null) },
  lockGroupDisabled: { label: /* @__PURE__ */ React8.createElement(LockIconWrapper, null) },
  lockRuleDisabled: { label: /* @__PURE__ */ React8.createElement(LockIconWrapper, null) },
  shiftActionDown: { label: /* @__PURE__ */ React8.createElement(ShiftDownIconWrapper, null) },
  shiftActionUp: { label: /* @__PURE__ */ React8.createElement(ShiftUpIconWrapper, null) }
};

// src/useMuiComponents.ts
import {
  Close as CloseIcon,
  ContentCopy as ContentCopyIcon,
  DragIndicator,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  Lock as LockIcon,
  LockOpen as LockOpenIcon
} from "@mui/icons-material";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Input,
  ListSubheader,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Switch,
  TextareaAutosize
} from "@mui/material";
import { useContext as useContext8, useMemo } from "react";
var defaultMuiComponents = {
  DragIndicator,
  Button,
  Checkbox,
  CloseIcon,
  ContentCopyIcon,
  FormControl,
  FormControlLabel,
  Input,
  KeyboardArrowDownIcon,
  KeyboardArrowUpIcon,
  ListSubheader,
  LockIcon,
  LockOpenIcon,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Switch,
  TextareaAutosize
};
var useMuiComponents = (preloadedComponents) => {
  const muiComponentsFromContext = useContext8(RQBMaterialContext);
  const initialComponents = useMemo(
    () => preloadedComponents && muiComponentsFromContext ? {
      ...defaultMuiComponents,
      ...muiComponentsFromContext,
      ...preloadedComponents
    } : preloadedComponents ? { ...defaultMuiComponents, ...preloadedComponents } : muiComponentsFromContext ? { ...defaultMuiComponents, ...muiComponentsFromContext } : defaultMuiComponents,
    [muiComponentsFromContext, preloadedComponents]
  );
  return initialComponents;
};

// src/index.tsx
var materialControlElements = {
  actionElement: MaterialActionElement,
  dragHandle: MaterialDragHandle,
  notToggle: MaterialNotToggle,
  shiftActions: MaterialShiftActions,
  valueEditor: MaterialValueEditor,
  valueSelector: MaterialValueSelector
};
var MaterialContextProvider = getCompatContextProvider({
  key: "material",
  controlElements: materialControlElements,
  translations: materialTranslations
});
var QueryBuilderMaterial = ({ muiComponents: muiComponentsProp, ...props }) => {
  const muiComponents = useMuiComponents(muiComponentsProp);
  const ctxValue = useMemo2(
    () => ({ ...muiComponents, ...muiComponentsProp }),
    [muiComponents, muiComponentsProp]
  );
  return /* @__PURE__ */ React9.createElement(RQBMaterialContext.Provider, { value: ctxValue }, /* @__PURE__ */ React9.createElement(MaterialContextProvider, { ...props }));
};
export {
  MaterialActionElement,
  MaterialDragHandle,
  MaterialNotToggle,
  MaterialShiftActions,
  MaterialValueEditor,
  MaterialValueSelector,
  QueryBuilderMaterial,
  RQBMaterialContext,
  defaultMuiComponents,
  materialControlElements,
  materialTranslations,
  useMuiComponents
};
//# sourceMappingURL=react-querybuilder_material.mjs.map